<script>

	export let lang='en', productCode=false, propertiesObj=false, contentObj=false, priceObj=false, buyabilityObj=false, isSkeleton=false, hasWishlist=true, hasAddToCart=false, hasCompare=false, certonaType=false, recToken= false, pricePerSqFt

	const en = lang!='fr'

	const categoryId = Number(window.location.pathname.match(/\/c\/(\d*)/)?.[1] || 0)
	let inCompare = false
	let inWishlist = false
	let preferredStore = false
    let monetateId = window.getCookie('mt.v') || false
	let calculatedPricePerSqFt = formatMoney((priceObj.salePrice || priceObj.price) / pricePerSqFt)


	function formatSKU(productCode) {
		productCode = String(productCode)
		return `${productCode.substring(0,4)}-${productCode.substring(4)}`
	}

	function formatMoney(amount) {
		return new Intl.NumberFormat(`${lang}-CA`, { style: 'currency', currency: 'CAD' }).format(amount)
	}

	function makePrice(priceObj, uom='EA') {
		if (priceObj.salePrice) {
			return `${formatMoney(priceObj.salePrice)}<small>/${uom}</small><small class="Light"> ${en ? 'was' : 'était'} ${formatMoney(priceObj.price)}</small>`
		} else {
			return `${formatMoney(priceObj.price)}<small>/${uom}</small>`
		}
	}

	function openProductLocator(productCode, productName, productBrand) {
		window.dispatchEvent(new CustomEvent('hh-mfe-product-locator', {
			detail: {
				productCode: productCode,
				productName: productName,
				productBrand: productBrand
			}
		}))
	}

	function openHeaderLocation() {
		console.log('openHeaderLocation')
		const target = document.querySelector('#hh-mfe-header-location > a')
		return target.click() || false
	}

	function wishlistAdd() {
		const event = new CustomEvent('hhWishlistAdd', {
			detail: {
				lang: lang,
				productData: {
					productCode: productCode,
					quantity: 1
				}
			}
		})
		window.dispatchEvent(event);
	}


	function wishlistCheck() {
		const wishlistProducts = JSON.parse(localStorage.wishlistProducts || '[]') || []
		inWishlist = wishlistProducts.includes(productCode)
	}

	function compareToggle() {
		if (!categoryId || !hasCompare) return

		let compareProducts = JSON.parse(localStorage.compareProducts || '{}') || {}

		if (!compareProducts[categoryId]) {
			compareProducts[categoryId] = []
		}

		if (compareProducts[categoryId]?.includes(productCode)) {
			// remove
			compareProducts[categoryId] = compareProducts[categoryId].filter(p => p!=productCode)
		} else {
			// warn about limit and return
			if (compareProducts[categoryId].length > 3) {
				return //alert('You can only have up to 4 items in your compare')
			}
			// add
			compareProducts[categoryId].push(productCode)
		}

		localStorage.compareProducts = JSON.stringify(compareProducts)

		window.dispatchEvent(new Event('hhCompareChanged'))
	}

	function compareCheck() {
		if (!categoryId || !hasCompare) return
		const compareProducts = JSON.parse(localStorage.compareProducts || '{}') || {}
		inCompare = compareProducts[categoryId]?.includes(productCode) || false
	}

	function getStoreData() {
		preferredStore = localStorage.preferredStore
			? JSON.parse(localStorage.preferredStore) || false
			: false;
	}

	function handleClick() {
		window.dispatchEvent(new Event('openMyStore'));
	}

    async function productClickHandler(){
        if(monetateId && recToken) await fetch(`https://monetate-recs-proxy.homehardware.dev/?monetateId=${monetateId}&recClicks=${recToken}`)
        window.location.href = `/${lang}/${contentObj.seoFriendlyUrl}/p/${productCode}`
    }

	function getFulfillmentMethod() {
        const isPickup = (buyabilityObj?.codes.includes('IN_STOCK_ONLINE') || buyabilityObj?.codes.includes('BOPIS_ONLY'))
            && (buyabilityObj?.inventory?.warehouse > 0 || buyabilityObj?.inventory?.store > 0)
        return isPickup ? 'Pickup' : 'Ship';
    }

	window.addEventListener('hhWishlistAdded', function() {
		wishlistCheck()
	}, false)

	window.addEventListener('hhCompareChanged', function() {
		compareCheck()
	}, false)

	window.addEventListener('storechanged', function() {
		getStoreData()
	}, false)

	getStoreData()
	wishlistCheck()
	compareCheck()

</script>





{#if isSkeleton}

<section class="ProductCard Skeleton">
	<a class="ProductCardThumb" href="#">
		<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="loading" width="200" height="200" loading="lazy" />
	</a>
	<a class="ProductCardContent" href="#">
		<h3 class="h4 Light"><strong>▇▇▇▇</strong> ▇▇▇▇▇ ▇▇ ▇▇▇ ▇▇</h3>
		<code class="ProductCode">▇▇▇▇▇</code>
	</a>
	<p class="Price">
		▇▇▇▇ ▇
	</p>
	<div class="Rating" aria-label="Loading" style="--rating: 0"></div>
	<div>
		<p class="IconData Pointer">
			<img class="Icon" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="locate" width="0" height="0" loading="lazy" />
			▇▇▇▇ ▇▇ ▇▇▇
		</p>
		<p class="IconData Pointer">
			<img class="Icon" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="favorite" width="0" height="0" loading="lazy" />
			▇▇▇▇ ▇ ▇▇
		</p>
	</div>
</section>

{:else}

<section class="ProductCard" data-product-data="{JSON.stringify({productCode, contentObj, priceObj})}" data-certona-type="{certonaType}">
	<a class="ProductCardThumb" href="/{lang}/{contentObj.seoFriendlyUrl}/p/{productCode}{certonaType ? '?rrec=true' : '' }" on:click|preventDefault={productClickHandler}>
		<!-- <img src="https://homehardware.sirv.com/products/{productCode.substring(0,4)}/{productCode}.view?thumb=image&w=500&q=75" alt="{contentObj.productName}" width="200" height="200" loading="lazy" /> -->
		<img
			src="https://homehardware.sirv.com/products/{productCode.substring(0,4)}/{productCode}.view?thumb=image&w=500&q=75"
			alt="{contentObj.productName}"
			width="200"
			height="200"
			onerror={`this.src='https://homehardware.sirv.com/hh/icons/Icon_150x150_ImageComingSoon.grey.${lang}.svg'`}
			loading="lazy"
		/>
	</a>
	<a class="ProductCardContent" href="/{lang}/{contentObj.seoFriendlyUrl}/p/{productCode}{certonaType ? '?rrec=true' : ''}" on:click|preventDefault={productClickHandler}>
		<h3 class="h4 Light"><strong>{contentObj?.brandName || ''}</strong> {contentObj.productName}</h3>
		<code class="ProductCode">#{formatSKU(productCode)}</code>
	</a>
	{#if priceObj && priceObj.price != 999999}
		{#if (buyabilityObj?.codes?.includes('FULL_ASSORTMENT'))}
		<!-- Don't Show Price -->
			<div class="ProductFlags">
				{#if propertiesObj?.tenantDynattribute21 && propertiesObj?.tenantDynattribute21?.value?.includes('Energy Star')}
					<img src="https://homehardware.sirv.com/hh/svg/EnergyStar_Blue_RGB_Logo.svg" alt="energy star logo" height="34" width="34" />
				{/if}
				{#if propertiesObj?.isMadeInCanada}
					<img src={ en ? "https://homehardware.sirv.com/hh/icons/icon-MIC.EN.svg" : "https://homehardware.sirv.com/hh/icons/icon-MIC.FR.svg"} alt="made in canada logo" height="34" width="34" />
				{/if}
				{#if propertiesObj?.isProductOfCanada}
					<img src={ en ? "https://homehardware.sirv.com/hh/icons/icon-CanProduct.EN.svg": "https://homehardware.sirv.com/hh/icons/icon-CanProduct.FR.svg"} alt="product of canada logo" height="34" width="34" />
				{/if}
			</div>
		{:else}
			<div class="ProductFlags">
				{#if propertiesObj?.tenantDynattribute295 && document.documentElement?.dataset?.badgesLockedInPrices == 'true'}
					<img src={`https://homehardware.sirv.com/hh/icons/LockedInLowPrice_${lang === 'fr' ? 'FR_' : ''}x50.svg`} alt="Locked-In-Price Logo" width="60" height="34" loading="lazy"/>
				{:else if propertiesObj?.tenantDynattribute71}
					<span class="ClearanceFlag">{en ? 'Clearance' : 'Liquidation'}</span>
				{:else if priceObj.salePrice}
					{#if propertiesObj?.isOnlineOnlyProduct}
						<span class="PriceFlag">{en ? 'ONLINE ONLY SALE' : 'VENTE EN LIGNE SEULEMENT'}</span>
					{:else}
						<span class="PriceFlag">{en ? 'Sale' : 'vente'}</span>
					{/if}
				{/if}
				{#if propertiesObj?.tenantDynattribute21 && propertiesObj?.tenantDynattribute21?.value?.includes('Energy Star')}
					<img src="https://homehardware.sirv.com/hh/svg/EnergyStar_Blue_RGB_Logo.svg" alt="energy star logo" height="34" width="34" />
				{/if}
				{#if propertiesObj?.isMadeInCanada}
					<img src={ en ? "https://homehardware.sirv.com/hh/icons/icon-MIC.EN.svg" : "https://homehardware.sirv.com/hh/icons/icon-MIC.FR.svg"} alt="made in canada logo" height="34" width="34" />
				{/if}
				{#if propertiesObj?.isProductOfCanada}
					<img src={ en ? "https://homehardware.sirv.com/hh/icons/icon-CanProduct.EN.svg": "https://homehardware.sirv.com/hh/icons/icon-CanProduct.FR.svg"} alt="made in canada logo" height="34" width="34" />
				{/if}
			</div>
			<a class="Price" href="/{lang}/{contentObj.seoFriendlyUrl}/p/{productCode}{certonaType ? '?rrec=true' : ''}">
				{@html makePrice(priceObj, propertiesObj?.tenantHhSellingUom?.stringValue)}
				{#if pricePerSqFt}
					{#if propertiesObj?.tenantHhSellingUom?.stringValue == 'CT'}
						<span class="h4 Light">{@html `(${calculatedPricePerSqFt}<small>/${en ? 'case': 'caisse'}</small>)`}</span>
					{:else }
						<span class="h4 Light">{@html `(${calculatedPricePerSqFt}<small>/${en ? 'SQ. FT.': 'pi<sup>2</sup>'}</small>)`}</span>
					{/if}
				{/if}
			</a>
		{/if}
	{:else }
		<div class="ProductFlags">
			{#if propertiesObj?.tenantDynattribute21 && propertiesObj?.tenantDynattribute21?.value?.includes('Energy Star')}
				<img src="https://homehardware.sirv.com/hh/svg/EnergyStar_Blue_RGB_Logo.svg" alt="energy star logo" height="34" width="34" />
			{/if}
			{#if propertiesObj?.isMadeInCanada}
				<img src={ en ? "https://homehardware.sirv.com/hh/icons/icon-MIC.EN.svg" : "https://homehardware.sirv.com/hh/icons/icon-MIC.FR.svg"} alt="made in canada logo" height="34" width="34" />
			{/if}
			{#if propertiesObj?.isProductOfCanada}
				<img src={ en ? "https://homehardware.sirv.com/hh/icons/icon-CanProduct.EN.svg": "https://homehardware.sirv.com/hh/icons/icon-CanProduct.FR.svg"} alt="product of canada logo" height="34" width="34" />
			{/if}
		</div>
	{/if}
	{#if en}
		<a class="Rating" href="/{lang}/{contentObj.seoFriendlyUrl}/p/{productCode}{certonaType ? '?rrec=true' : ''}" style="--rating: {propertiesObj?.tenantRating?.value?.toFixed(1) || 0}" aria-label="Rating of this product is {propertiesObj?.tenantRating?.value?.toFixed(1) || 0} out of 5.">({propertiesObj?.tenantTotalReviewCount?.value || 0})</a>
	{:else}
		<a class="Rating" href="/{lang}/{contentObj.seoFriendlyUrl}/p/{productCode}{certonaType ? '?rrec=true' : ''}" style="--rating: {propertiesObj?.tenantRatingFr?.value?.toFixed(1) || 0}" aria-label="Rating of this product is {propertiesObj?.tenantRatingFr?.value?.toFixed(1) || 0} out of 5.">({propertiesObj?.tenantTotalReviewCountFr?.value || 0})</a>
	{/if}

	{#if buyabilityObj}
	<div>
		{#if buyabilityObj?.codes?.includes('NOT_IN_PRICELIST')}
			<p class="IconData">
				<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.crossed-red.svg" alt="Red Cross" width="0" height="0" loading="lazy" />
				<span>{en ? `Not available at your store` : 'N’est pas disponible à votre magasin'}</span>
			</p>
			<a href="javascript:void(0)" class="IconData" on:click|preventDefault={openProductLocator(productCode,contentObj?.productName, contentObj?.brandName)}>
				<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-location.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
				<span class="findNearby">{en ? 'Find Nearby' : 'Le trouver à proximité'}</span>
			</a>
		{:else if buyabilityObj?.codes?.includes('ONLY_BUILDING_CENTRE')}
			<p class="IconData">
				<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.crossed-red.svg" alt="Red Cross" width="0" height="0" loading="lazy" />
				<span>{en ? `Only available at Building Centre Locations` : 'Offert seulement dans les Centres de rénovation'}</span>
			</p>
			<a href="javascript:void(0)" class="IconData" on:click|preventDefault={openProductLocator(productCode,contentObj?.productName, contentObj?.brandName)}>
				<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-location.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
				<span class="findNearby">{en ? 'Find Nearby' : 'Le trouver à proximité'}</span>
			</a>
		{:else if buyabilityObj?.codes?.includes('SUPPLIER_DIRECT') && !buyabilityObj?.buyable}
			{#if buyabilityObj?.codes?.includes('NRTI') && buyabilityObj?.codes?.includes('DISPLAY_SP_INVENTORY')}
				{#if buyabilityObj.inventory?.store > 500 }
					<p class="IconData">
						<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
						<span>{@html en ? `<strong>500+</strong> Available In-Store` : `<strong>500+</strong> Disponibles en magasin`}</span>
					</p>
				{:else if buyabilityObj.inventory?.store > 0}
					<p class="IconData">
						<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
						<span>{@html en ? `<strong>${buyabilityObj.inventory?.store}</strong> Available In-Store` : `<strong>${buyabilityObj.inventory?.store}</strong> Disponibles en magasin`}</span>
					</p>
				{/if}
				<a href="javascript:void(0)" class="IconData" on:click|preventDefault={openHeaderLocation}>
				{#if buyabilityObj?.codes?.includes('SPECIAL_ORDER') && priceObj.price != 4999 && buyabilityObj?.codes?.includes('RETAIL_ITEM') && buyabilityObj.inventory?.store >= 0 }
					<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
					<span>{@html en ? `Contact <strong>${preferredStore.name}</strong> to order` : `Communiquez avec <strong>${preferredStore.name}</strong> pour passer une commande`}</span>
				{:else if buyabilityObj?.codes?.includes('RETAIL_ITEM') && buyabilityObj.inventory?.store > 0 }
                    <img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
                    <span>{en ? 'Available in store only' : 'Offert seulement en magasin'}</span>
                {:else if buyabilityObj?.codes?.includes('RETAIL_ITEM') && buyabilityObj.inventory?.store < 1  }
                    <img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
                    <span>{@html en ? `Contact <strong>${preferredStore.name}</strong> for In-Store availability` : `Communiquez avec <strong>${preferredStore.name}</strong> pour connaître l’état des stocks`}</span>
				{:else if buyabilityObj.inventory?.store > 0 }
                    <img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
                    <span>{@html en ? `Contact <strong>${preferredStore.name}</strong> for price` : `Communiquez avec <strong>${preferredStore.name}</strong> pour le prix`}</span>
				{:else}
					<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
                    <span>{@html en ? `Contact <strong>${preferredStore.name}</strong> for price and availability` : `Communiquez avec <strong>${preferredStore.name}</strong> pour le prix et la disponibilité`}</span>
				{/if}
				</a>
			{:else}
				<a href="javascript:void(0)" class="IconData" on:click|preventDefault={openHeaderLocation}>
				<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
				{#if buyabilityObj?.codes?.includes('SPECIAL_ORDER') && buyabilityObj?.codes?.includes('RETAIL_ITEM')  }
                    <span>{@html en ? `Contact <strong>${preferredStore.name}</strong> to order` : `Communiquez avec <strong>${preferredStore.name}</strong> pour passer une commande`}</span>
				{:else if buyabilityObj?.codes?.includes('RETAIL_ITEM') }
                    <span>{@html en ? `Contact <strong>${preferredStore.name}</strong> for In-Store availability` : `Communiquez avec <strong>${preferredStore.name}</strong> pour connaître l’état des stocks`}</span>
				{:else}
                    <span>{@html en ? `Contact <strong>${preferredStore.name}</strong> for price and availability` : `Communiquez avec <strong>${preferredStore.name}</strong> pour le prix et la disponibilité`}</span>
				{/if}
			</a>
			{/if}
		{:else}
			{#if buyabilityObj?.codes?.includes('IN_STOCK_ONLINE')}
				{#if buyabilityObj.codes?.includes('NRTI') && buyabilityObj.inventory?.store <= 0}
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
					<span>{en ? 'FREE Ship to Store' : 'Livraison GRATUITE en magasin'}</span>
				</p>
				{:else}
			    <p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
					<span>{en ? 'FREE In-Store Pick-up' : 'Ramassage gratuit en magasin'}</span>
				</p>
                {/if}
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="red cross" width="0" height="0" loading="lazy" />
					<span>{en ? 'Ship to Home' : 'Livraison à domicile'}</span>
				</p>
			{:else if buyabilityObj?.codes?.includes('BOPIS_ONLY')}
			    {#if buyabilityObj.codes?.includes('NRTI') && buyabilityObj.inventory?.store <= 0}
			        <p class="IconData">
				    <img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
				    <span>{en ? 'FREE Ship to Store' : 'Livraison GRATUITE en magasin'}</span>
			        </p>
			   {:else}
			        <p class="IconData">
				    <img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
				    <span>{en ? 'FREE In-Store Pick-up' : 'Ramassage gratuit en magasin'}</span>
			        </p>
			   {/if}
			{:else if buyabilityObj?.codes?.includes('SHIP_TO_HOME_ONLY')}
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="red cross" width="0" height="0" loading="lazy" />
					<span>{en ? 'Ship to Home' : 'Livraison à domicile'}</span>
				</p>
			{/if}

			{#if buyabilityObj.codes?.includes('NRTI') && propertiesObj?.isOnlineOnlyProduct }
				<!-- Do not show availability count OPTIMUS-594 | Nawanit -->
			{:else if buyabilityObj.codes?.includes('NRTI') && buyabilityObj.inventory?.store > 500 }
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
					<span>{@html en ? `<strong>500+</strong> Available In-Store` : `<strong>500+</strong> Disponibles en magasin`}</span>
				</p>
			{:else if buyabilityObj.codes?.includes('NRTI') && buyabilityObj.inventory?.store > 0 }
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
					<span>{@html en ? `<strong>${buyabilityObj.inventory?.store}</strong> Available In-Store` : `<strong>${buyabilityObj.inventory?.store}</strong> Disponibles en magasin`}</span>
				</p>
			{:else if buyabilityObj.codes?.includes('NRTI') && buyabilityObj.inventory?.store <= 0 && (buyabilityObj?.codes?.includes('IN_STOCK_ONLINE') || buyabilityObj?.codes?.includes('SHIP_TO_HOME_ONLY') || buyabilityObj?.codes?.includes('BOPIS_ONLY')) }
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.crossed-red.svg" alt="red cross" width="0" height="0" loading="lazy" />
					<span>{en ? 'Sold out In-Store' : 'Épuisé en magasin'}</span>
				</p>
			{/if}









			<!-- {#if buyabilityObj?.codes?.includes('IN_STOCK_ONLINE') || buyabilityObj?.codes?.includes('SHIP_TO_HOME_ONLY') || buyabilityObj?.codes?.includes('BOPIS_ONLY')}
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.checked-green.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
					<span>{en ? 'Available online' : 'Disponible en ligne'}</span>
				</p>
			{:else }
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.crossed-red.svg" alt="red cross" width="0" height="0" loading="lazy" />
					<span>{en ? 'Sold out online' : 'Vendu en ligne'}</span>
				</p>
			{/if} -->

			{#if buyabilityObj?.codes?.includes('TEMPORARY_OUT_OF_STOCK')}
				{#if !buyabilityObj?.debug?.isEcommerceItem && buyabilityObj?.inventory?.warehouse}
					<p class="IconData">
						<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="phone" width="0" height="0" loading="lazy" />
						<span>{en ? 'Contact' : 'Contactez'} <a class="Heavy" on:click={handleClick}>{preferredStore.name}</a> {en ? 'to order' : 'pour commander'}</span>
					</p>
				{:else}
					<p class="IconData">
						<img class="Icon" src="https://homehardware.sirv.com/hh/svg/icon.crossed-red.svg" alt="red cross" width="0" height="0" loading="lazy" />
						<span>{en ? 'Temporarily out of stock' : 'Temporairement en rupture de stock'}</span>
					</p>
					<a href="javascript:void(0)" class="IconData" on:click|preventDefault={openProductLocator(productCode,contentObj?.productName, contentObj?.brandName)}>
						<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-location.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
						<span class="findNearby">{en ? 'Find Nearby' : 'Le trouver à proximité'}</span>
					</a>
				{/if}
			{/if}

			{#if buyabilityObj?.codes?.includes('AVAILABLE_IN_STORE_ONLY')}
				<p class="IconData">
					<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="green checkmark" width="0" height="0" loading="lazy" />
					<span>{en ? 'Available in store only' : 'Offert seulement en magasin'}</span>
				</p>
			{/if}

			<!-- {#if !buyabilityObj.codes?.includes('NRTI') && buyabilityObj.inventory?.sth <= 0 } -->
			{#if buyabilityObj.codes?.includes('CONTACT_STORE') }
				<a href="javascript:void(0)" class="IconData" on:click|preventDefault={openHeaderLocation}>
					<img class="Icon" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="location marker" width="0" height="0" loading="lazy" />
					<span>{@html en ? `Contact <strong>${preferredStore.name}</strong> for In-Store availability` : `Communiquez avec <strong>${preferredStore.name}</strong> pour connaître l’état des stocks`}</span>
				</a>
			{/if}


		{/if}
	</div>
	{/if}

	{#if hasAddToCart && document.documentElement?.dataset?.plpAddToCart == 'true'}
		{#if buyabilityObj?.buyable}
			{@const productInfo = [{		            
				"productCode": productCode,
				"quantity": 1,
				"method": getFulfillmentMethod()
			}]}
			<hh-add-button productInfo={JSON.stringify(productInfo)}></hh-add-button>
		{:else}
			<button class="Button ButtonBlock ButtonSecondary addToCartBtn" on:click={productClickHandler}>{en ? 'View Details' : 'Afficher les détails'}</button>
		{/if}
	{/if}

	{#if hasWishlist && inWishlist}
	<button type="button" class="Wishlist">
		<img src="https://homehardware.sirv.com/hh/icons/icon-heart.red.svg" id="btn-wishlist" alt="red heart" />
	</button>
	{:else if hasWishlist}
	<button type="button" class="Wishlist" on:click={wishlistAdd}>
		<img src="https://homehardware.sirv.com/hh/icons/icon-heart.blackoutline.svg" id="btn-wishlist" alt="black outline heart" />
	</button>
	{/if}

	{#if hasCompare && inCompare}
	<button type="button" class="Compare" on:click={compareToggle}>
		<img src="https://homehardware.sirv.com/hh/icons/icon-compare.check-red.svg" alt="checked box" />{en ? `Compare` : `Comparer`}
	</button>
	{:else if hasCompare}
	<button type="button" class="Compare" on:click={compareToggle}>
		<img src="https://homehardware.sirv.com/hh/icons/icon-compare.empty.svg" alt="un-checked box" /> {en ? `Compare` : `Comparer`}
	</button>
	{/if}
	<slot></slot>
</section>

{/if}